module.exports = __webpack_public_path__ + "static/media/hoa-bg.0ad60ffa.jpg";